import { render, staticRenderFns } from "./digikey-headers.vue?vue&type=template&id=2289e357&"
import script from "./digikey-headers.vue?vue&type=script&lang=js&"
export * from "./digikey-headers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports